import { useDataSubmit } from 'Simple/Data.js'

export function useOnLauncherResolved(props) {
  let submit = useDataSubmit({
    context: 'patient_image',
    viewPath: props.viewPath,
  })

  return async function onLauncherResolved({ launcher, response }) {
    switch (launcher.type) {
      case 'URL_HTTP':
      case 'URL_STATIC': {
        switch (launcher.displayFormat) {
          case 'MODAL_FULLSCREEN': {
            await submit({
              type: 'open_apps_launcher_url_modal_fullscreen',
              launcher: {
                ...launcher,
                url: response.url,
              },
            })
            break
          }

          case 'NEW_WINDOW':
          default: {
            window.open(response.url)
            break
          }
        }
        break
      }

      default: {
        break
      }
    }
  }
}
